import { HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoadingService } from "../services/loading.service";
import { catchError, finalize, NEVER, Observable, throwError } from "rxjs";
import { Router } from "@angular/router";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { environment } from "../../environments/environment";
import { MsalService } from "@azure/msal-angular";

export const SkipLoading =
  new HttpContextToken<boolean>(() => false);

@Injectable()
export class AppInterceptor
  implements HttpInterceptor {
  constructor(private loadingService: LoadingService, private router: Router, private authService: MsalService) {
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // add token expiry logic here also
    let access_token = localStorage.getItem('access_token');
    if (!access_token || this.valid_token(access_token) == false) {
      this.refresh_access_token();
    }

    req = req.clone({
      setHeaders: {
        'Content-Type': 'application/json; charset=utf-8',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('access_token')
      },
    });

    // Check for a custom attribute 
    // to avoid showing loading spinner

    if (req.context.get(SkipLoading)) {
      // Pass the request directly to the next handler
      return next.handle(req);
    }

    // Turn on the loading spinner
    this.loadingService.loadingOn();

    return next.handle(req).pipe(
      catchError((err) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            localStorage.clear();
            this.router.navigate(['/login']);
            return NEVER;
          }
        }
        return throwError(() => err);
      }),
      finalize(() => {
        // Turn off the loading spinner
        this.loadingService.loadingOff();
      })
    );
  }

  refresh_access_token() {
    let silent_request = {
      scopes: [...environment.apiConfig.scopes],
      account: this.authService.instance.getAllAccounts()[0],
      forceRefresh: true
    };
    this.authService.acquireTokenSilent(silent_request).subscribe({
      next: (res: any) => {
        localStorage.setItem('access_token', res.idToken);
      },
      error: (err: any) => {
        if (err instanceof InteractionRequiredAuthError) {
          // fallback to interaction when silent call fails
          return this.authService.acquireTokenPopup(silent_request);
        }
        return;
      },
    });
  }

  valid_token(accessToken: string) {
    if (!accessToken) return false

    accessToken = accessToken.split('.')[1];
    accessToken = window.atob(accessToken);
    let accessToken_json = JSON.parse(accessToken);
    const now = Math.floor(Date.now() / 1000);
    const exp = accessToken_json.exp;
    const expiry_time_minutes_from_now = Math.ceil((accessToken_json.exp - now) / 60)
    if (accessToken_json.exp < now || expiry_time_minutes_from_now <= 58) {
      return false;
    }
    return true;
  }
}